var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.124,
    height: 75.124,
    viewBox: "0 0 75.124 75.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.171,
    y1: 0.915,
    x2: 0.874,
    y2: 0.164,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.562,2A37.562,37.562,0,1,0,77.124,39.562,37.562,37.562,0,0,0,39.562,2ZM52.3,21.47h2.592l.8-2.467a1.6,1.6,0,0,1,3.03,0l.8,2.467h2.592a1.6,1.6,0,0,1,.939,2.88l-2.1,1.528.8,2.467a1.587,1.587,0,0,1-2.442,1.778l-2.1-1.528-2.091,1.528a1.617,1.617,0,0,1-1.878,0,1.574,1.574,0,0,1-.576-1.778l.8-2.467-2.1-1.528a1.6,1.6,0,0,1,.939-2.88ZM57.2,46.411c-7.362-.225-7.4-10.93,0-11.181a5.591,5.591,0,1,1,0,11.181ZM32.337,17.889h4.182l1.24-3.944a1.9,1.9,0,0,1,3.606,0l1.277,3.969,4.144-.025A1.894,1.894,0,0,1,47.9,21.294l-3.393,2.454,1.315,3.931a1.841,1.841,0,0,1-.689,2.1,1.86,1.86,0,0,1-2.216,0l-3.381-2.454-3.33,2.454a1.822,1.822,0,0,1-2.216,0,1.841,1.841,0,0,1-.689-2.1l1.29-3.969-3.368-2.416a1.894,1.894,0,0,1,1.114-3.406ZM46.185,38.41c-.288,8.727-12.946,8.739-13.234,0a6.617,6.617,0,1,1,13.234,0ZM16.8,21.47h2.617L20.2,19a1.6,1.6,0,0,1,3.03,0l.8,2.467h2.6a1.6,1.6,0,0,1,.927,2.88l-2.1,1.528.814,2.467a1.593,1.593,0,0,1-2.454,1.778l-2.091-1.528-2.116,1.528a1.6,1.6,0,0,1-1.866,0,1.574,1.574,0,0,1-.576-1.778l.8-2.467-2.1-1.528a1.6,1.6,0,0,1,.927-2.88ZM21.92,46.411a5.591,5.591,0,1,1,5.591-5.591,5.59,5.59,0,0,1-5.591,5.591ZM14.646,59.87a2.02,2.02,0,0,1-2-2.016V53.76a9.227,9.227,0,0,1,3.994-7.613,7.525,7.525,0,0,0,10,.513c.651-.914,1.214.025,1.841.551a14.432,14.432,0,0,0-1.966,7.012c0,.013-.013,5.321.025,5.647Zm36.034-.413a2,2,0,0,1-1.991,2H30.447a2.015,2.015,0,0,1-1.966-1.59c-.213-6.047-.576-11.456,5.334-15.162a8.489,8.489,0,0,0,11.494,0,11.083,11.083,0,0,1,4.971,6.573c.676,1.891.3,6.148.4,8.176Zm13.8.413H52.583c.063.125,0-5.559.025-5.647a13.141,13.141,0,0,0-2.016-6.961c.614-.538,1.24-1.553,1.9-.6a7.5,7.5,0,0,0,9.428,0c.651-.927,1.227.025,1.841.551a9.208,9.208,0,0,1,2.717,6.548v4.094a2.012,2.012,0,0,1-2,2.016Z",
    transform: "translate(-2 -2)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.45e21e1b05790eade11df4a491442ea1.svg";
export { ForwardRef as ReactComponent };